import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/** @category Relationships */
export function useRelationships(profileId?: string) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  return (
    useQuery(tokenizedApi.relationships.relationshipsQuery(profileId))?.data ||
    []
  ).filter((relationship) =>
    relationship.relationshipFlags?.includes('contact'),
  );
}
